import { render, staticRenderFns } from "./AssessmentQuestionInput.vue?vue&type=template&id=420d4e40&scoped=true"
import script from "./AssessmentQuestionInput.vue?vue&type=script&lang=js"
export * from "./AssessmentQuestionInput.vue?vue&type=script&lang=js"
import style0 from "./AssessmentQuestionInput.vue?vue&type=style&index=0&id=420d4e40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d4e40",
  null
  
)

export default component.exports